// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedAlarmHighAlarmDefault_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M52.5225 30.0783C54.5236 22.6098 50.0915 14.933 42.623 12.9319L43.1406 11C43.7948 11.1753 44.4287 11.3887 45.0404 11.6372C51.7977 14.3821 55.8538 21.4076 54.8524 28.632C54.7617 29.286 54.6296 29.9417 54.4543 30.5959L52.5225 30.0783ZM43.9942 15.5416C43.3947 15.2681 42.7646 15.0404 42.107 14.8641C42.1064 14.864 42.1059 14.8638 42.1053 14.8637L41.5877 16.7956C41.5886 16.7958 41.5895 16.796 41.5904 16.7963C41.5905 16.7963 41.5906 16.7963 41.5908 16.7964C42.2565 16.975 42.8884 17.2167 43.4818 17.5134C47.3448 19.4449 49.5759 23.7059 48.8735 28.042C48.8195 28.3756 48.7481 28.7096 48.6588 29.043L50.5906 29.5606C50.5914 29.5576 50.5922 29.5545 50.5931 29.5515C50.6991 29.1544 50.784 28.7567 50.8483 28.3595C50.8901 28.1013 50.9233 27.8433 50.948 27.5858C51.4207 22.6555 48.7839 17.9279 44.3782 15.7251C44.2517 15.6619 44.1237 15.6007 43.9942 15.5416ZM42.5853 19.3017C42.1099 19.064 41.6035 18.8703 41.07 18.7274L40.5524 20.6593C40.5532 20.6595 40.554 20.6597 40.5548 20.6599C43.7541 21.5185 45.6525 24.8077 44.795 28.0077L46.7269 28.5254C46.7272 28.5241 46.7276 28.5229 46.7279 28.5216C46.7989 28.2561 46.8557 27.9902 46.8987 27.7246C46.9636 27.3241 46.9972 26.9244 47.0011 26.5283C47.0298 23.6256 45.4648 20.915 42.9367 19.4885C42.8215 19.4235 42.7044 19.3612 42.5853 19.3017ZM47.5912 46L32 18.0999L16.4087 46L47.5912 46ZM33.7459 17.1242C32.9826 15.7584 31.0173 15.7584 30.2541 17.1242L14.6628 45.0244C13.9178 46.3575 14.8815 48 16.4087 48H47.5912C49.1184 48 50.0821 46.3575 49.3371 45.0244L33.7459 17.1242Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedAlarmHighAlarmDefault is a generated icon component.
 */
let IconMedAlarmHighAlarmDefault = IconMedAlarmHighAlarmDefault_1 = class IconMedAlarmHighAlarmDefault extends IconBaseElement {
    render() {
        return html `${IconMedAlarmHighAlarmDefault_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedAlarmHighAlarmDefault.icons = new Map([
    ['s8', _s64IconSvg],
    ['s12', _s64IconSvg],
    ['s16', _s64IconSvg],
    ['s24', _s64IconSvg],
    ['s32', _s64IconSvg],
    ['s40', _s64IconSvg],
    ['s48', _s64IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconMedAlarmHighAlarmDefault = IconMedAlarmHighAlarmDefault_1 = __decorate([
    customElement('zui-icon-med-alarm-high-alarm-default')
], IconMedAlarmHighAlarmDefault);
export { IconMedAlarmHighAlarmDefault };
